import FpuiButton from './FpuiButton'
import FpuiSelectDynamicParameters from './FpuiSelectDynamicParameters'
import FpuiSelectCharts from './FpuiSelectCharts'
import FpuiHelper from './FpuiHelper'
import FpuiHelperPopover from './FpuiHelperPopover'
import { FpLoader, FpSpinner } from './loader'
import { FpuiSelectList } from './select-list'
import FpuiProgressBar from './FpuiProgressBar.vue'
import {
  FpuiInputText,
  FpuiInputTextAddon,
  FpuiInputSearch,
  FpuiInputPassword,
  FpuiInputTextarea,
  FpuiInputTextEditable,
  FpuiInputSelect,
  FpuiInputNumber,
  FpuiInputCheckbox,
  FpuiInputRadio,
  FpuiInputTag,
  FpuiInputTags,
  FpuiInputStyle,
  FpuiInputImage,
  FpuiInputToggle,
  FpuiInputFileZone,
  FpuiDropdownList,
  FpuiIconSelect
} from './form'
import { FpuiModalBody, FpuiModalHeader, FpuiModalConfirm, FpuiModalMessage } from './modals'

import FpuiLayout from './layout/FpuiLayout'
import FpuiLayoutResizer from './layout/FpuiLayoutResizer'
import FpuiActionList from './action-list'
import FpuiTreeView from './tree-view'
import FpuiSimpleTree from './simple-tree'

import FpuiSteps from './steps/Steps'
import FpuiStep from './steps/Step'

import FpuiAccordion from './accordion/FpuiAccordion'
import FpuiAccordionSection from './accordion/FpuiAccordionSection'
import FpuiTabs from './tabs/Tabs'
import FpuiTab from './tabs/Tab'
import MultiSelect from 'vue-multiselect'

import FpuiRequestBuilderData from './request-builder/Data'
import FpuiRequestBuilderScale from './request-builder/Scale'
import FpuiRequestBuilderFilter from './request-builder/Filter'

import FpuiMonitoringItem from './monitoring'

import { Dropdown, DropdownHead, DropdownOptions, DropdownOption } from './dropdown'

export default [
  { name : 'fpui-progress-bar', component:FpuiProgressBar },
  { name: 'fp-loader', component: FpLoader },
  { name: 'fp-spinner', component: FpSpinner },
  { name: 'fpui-button', component: FpuiButton },
  { name: 'fpui-helper', component: FpuiHelper },
  { name: 'fpui-helper-popover', component: FpuiHelperPopover },
  { name: 'fpui-select-dynamic-parameters', component: FpuiSelectDynamicParameters },
  { name: 'fpui-select-charts', component: FpuiSelectCharts },
  { name: 'fpui-input-text', component: FpuiInputText },
  { name: 'fpui-input-text-addon', component: FpuiInputTextAddon },
  { name: 'fpui-input-search', component: FpuiInputSearch },
  { name: 'fpui-input-password', component: FpuiInputPassword },
  { name: 'fpui-input-textarea', component: FpuiInputTextarea },
  { name: 'fpui-input-text-editable', component: FpuiInputTextEditable },
  { name: 'fpui-input-select', component: FpuiInputSelect },
  { name: 'fpui-input-number', component: FpuiInputNumber },
  { name: 'fpui-input-checkbox', component: FpuiInputCheckbox },
  { name: 'fpui-input-radio', component: FpuiInputRadio },
  { name: 'fpui-input-tag', component: FpuiInputTag },
  { name: 'fpui-input-tags', component: FpuiInputTags },
  { name: 'fpui-input-style', component: FpuiInputStyle },
  { name: 'fpui-input-image', component: FpuiInputImage },
  { name: 'fpui-input-toggle', component: FpuiInputToggle },
  { name: 'fpui-input-file-zone', component: FpuiInputFileZone },
  { name: 'fpui-action-list', component: FpuiActionList },
  { name: 'fpui-tree-view', component: FpuiTreeView },
  { name: 'fpui-simple-tree', component: FpuiSimpleTree },
  { name: 'fpui-steps', component: FpuiSteps },
  { name: 'fpui-step', component: FpuiStep },
  { name: 'fpui-tabs', component: FpuiTabs },
  { name: 'fpui-tab', component: FpuiTab },
  { name: 'fpui-modal-body', component: FpuiModalBody },
  { name: 'fpui-modal-header', component: FpuiModalHeader },
  { name: 'fpui-modal-confirm', component: FpuiModalConfirm },
  { name: 'fpui-modal-message', component: FpuiModalMessage },
  { name: 'fpui-accordion', component: FpuiAccordion },
  { name: 'fpui-accordion-section', component: FpuiAccordionSection },
  { name: 'fpui-layout', component: FpuiLayout },
  { name: 'fpui-layout-resizer', component: FpuiLayoutResizer },
  { name: 'fpui-dropdown-list', component: FpuiDropdownList },
  { name: 'fpui-monitoring-item', component: FpuiMonitoringItem },
  { name: 'fpui-select-list', component: FpuiSelectList },
  { name: 'fpui-request-builder-data', component: FpuiRequestBuilderData },
  { name: 'fpui-request-builder-scale', component: FpuiRequestBuilderScale },
  { name: 'fpui-request-builder-filter', component: FpuiRequestBuilderFilter },
  { name: 'fpui-dropdown', component: Dropdown },
  { name: 'fpui-dropdown-head', component: DropdownHead },
  { name: 'fpui-dropdown-options', component: DropdownOptions },
  { name: 'fpui-dropdown-option', component: DropdownOption },
  { name: 'fpui-icon-select', component: FpuiIconSelect },
  { name: 'multiselect', component: MultiSelect }

]
